import React from "react";
import { useLang, translations } from "@/i18n";
import { LOCATIONS } from "@/lib/locations";
import { HOME_COPY as C, HOME_VENUE_COPY } from "@/data/homeContent";
import { HomeMedia } from "./HomeMedia";
import { Reveal, SectionLabel, TextLink } from "./HomePrimitives";
import { BookButton, MobileBookBar } from "./HomeBookings";

export const HomeLocations = () => {
  const { t } = useLang();
  return <section id="home-locales" className="rh-locales rh-wrap" data-testid="home-locations">
    <Reveal className="rh-locales-heading"><SectionLabel testId="home-locations-heading" number="07">{t(C.localesLabel)}</SectionLabel><p className="rh-statement" data-testid="home-locations-statement">{t(C.localesTitle)}</p></Reveal>
    {LOCATIONS.map((loc, index) => <article className={`rh-venue rh-venue-${loc.slug}`} key={loc.slug} data-testid={`home-location-${loc.slug}`}>
      <HomeMedia name={loc.slug} className="rh-venue-photo" sizes="(max-width: 767px) 100vw, 65vw">
        {!loc.image && <div className="rh-venue-placeholder" aria-hidden="true"><span>01</span><p>Valterna</p><small>RITUAL · VALENCIA</small></div>}
      </HomeMedia>
      <Reveal className="rh-venue-details">
        <span className="rh-label">0{index + 1} / {t(loc.area)}</span>
        <h3 data-testid={`home-location-name-${loc.slug}`}><span>Ritual</span>{loc.shortName}</h3>
        <p className="rh-venue-tagline">{t(HOME_VENUE_COPY[loc.slug])}</p>
        <address data-testid={`home-location-address-${loc.slug}`}>{loc.addressDisplay}</address>
        <p className="rh-venue-hours" data-testid={`home-location-hours-${loc.slug}`}>{t(loc.hours)}</p>
        <div className="rh-venue-actions"><BookButton venue={loc.slug} testId={`home-location-reserve-${loc.slug}`} /><TextLink to={`/locales/${loc.slug}`} testId={`home-location-details-${loc.slug}`}>{t(C.venueLink)}</TextLink></div>
        <div className="rh-venue-contact"><a href={`tel:${loc.phoneTel}`} data-testid={`home-location-call-${loc.slug}`}>{t(translations.common.call)} · {loc.phoneDisplay}</a><a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.addressDisplay)}`} target="_blank" rel="noopener noreferrer" data-testid={`home-location-map-${loc.slug}`}>{t(C.maps)} ↗</a></div>
      </Reveal>
    </article>)}
  </section>;
};

export const HomeReservation = () => {
  const { t } = useLang();
  return <section className="rh-reservation rh-wrap" data-testid="home-reservation-section">
    <SectionLabel testId="home-reservation-heading" number="08">{t(C.bookingLabel)}</SectionLabel>
    <p className="rh-statement" data-testid="home-reservation-statement">{t(C.bookingTitle)}</p>
    <div className="rh-reservation-actions"><BookButton testId="join-reservar" className="rh-reservation-desktop-book" /><MobileBookBar /><TextLink to="/menus-para-grupos" testId="home-reservation-groups">{t(C.groupsLink)}</TextLink></div>
  </section>;
};